import { hotjar } from 'react-hotjar';
import { useEffect } from 'react';

export const useHotjar = () => {
  useEffect(() => {
    if (!import.meta.env.VITE_HOTJAR_ID) {
      return;
    }

    hotjar.initialize(import.meta.env.VITE_HOTJAR_ID, 6);
  }, []);

  const setHotjarUser = ({ id, name, account }) => {
    if (!import.meta.env.VITE_HOTJAR_ID) {
      return;
    }
    if (hotjar.initialized()) {
      hotjar.identify(id, { account: account, userName: name });
    }
  };

  return { setHotjarUser };
};
